<template>
    <div class="show-owner-details">
        <div class="show-owner-details-header">
            <div>
                <h6>Responsable</h6>
                <p class="mb-0">Informations principales du compte client.</p>
            </div>
            <div class="show-owner-details-actions">
                <button
                    v-tooltip="getTooltip('Réinitialiser les tests d\'envois des mails ou des sms')"
                    class="btn btn-outline-secondary btn-square btn-sm"
                    @click="canShowResetLimiterModal = true"
                    :disabled="loading">
                    <feather type="refresh-ccw"></feather>
                </button>
                <button
                    v-tooltip="getTooltip($t('labels.form.actions.edit'))"
                    class="btn btn-success btn-square btn-sm"
                    @click="$emit('edit-owner')"
                    :disabled="loading">
                    <feather type="edit"></feather>
                </button>
                <button
                    v-tooltip="getTooltip($t('labels.form.actions.delete'))"
                    class="btn btn-danger btn-square btn-sm"
                    @click="deleteOwner()"
                    :disabled="loading">
                    <feather type="trash-2"></feather>
                </button>
            </div>
        </div>

        <div class="show-owner-details-grid">
            <div class="show-owner-details-item">
                <span>Prénom</span>
                <strong>{{ displayValue(capitalize(ownerDetails.firstname)) }}</strong>
            </div>
            <div class="show-owner-details-item">
                <span>Nom</span>
                <strong>{{ displayValue(capitalize(ownerDetails.lastname)) }}</strong>
            </div>
            <div class="show-owner-details-item">
                <span>Email</span>
                <strong>
                    <a :href="`mailto:${ownerDetails.email}`">{{ ownerDetails.email }}</a>
                </strong>
            </div>
            <div class="show-owner-details-item">
                <span>Téléphone</span>
                <strong>{{ displayValue(ownerDetails.tel) }}</strong>
            </div>
            <div v-if="isNoShow" class="show-owner-details-item">
                <span>N° client Fiducial</span>
                <strong>{{ displayValue(ownerDetails.fiducial_client_id) }}</strong>
            </div>
            <div v-if="isNoShow" class="show-owner-details-item">
                <span>N° client Pointex</span>
                <strong>{{ displayValue(ownerDetails.manhattan_licence_id) }}</strong>
            </div>
            <div v-if="isYservices" class="show-owner-details-item">
                <span>Compte Yproximité</span>
                <strong>{{ displayValue(ownerDetails.yprox_user_id) }}</strong>
            </div>
            <div class="show-owner-details-item">
                <span>Date d'inscription</span>
                <strong>{{ moment(ownerDetails.created_at).format("DD MMMM Y") }}</strong>
            </div>
        </div>

        <button v-if="isYservices" class="btn btn-outline-secondary btn-sm btn-circle mt-3" :disabled="loading" @click="sendResetPasswordLink">
            Envoyer un mail de réinitialisation du mot de passe
        </button>

        <reset-rate-limiter-modal v-if="canShowResetLimiterModal" :userId="ownerDetails.id" @close="canShowResetLimiterModal = false" />
    </div>
</template>

<script>
import moment from "moment";
import ResetRateLimiterModal from "../Modals/Admin/Clients/ResetRateLimiterModal.vue";

export default {
    data() {
        return {
            moment,
            loading: false,
            canShowResetLimiterModal: false,
        };
    },
    props: {
        ownerDetails: {
            required: true,
            type: Object,
        },
    },
    components: {
        ResetRateLimiterModal,
    },
    methods: {
        displayValue(value) {
            return value || "Non renseigné";
        },
        sendResetPasswordLink() {
            if (!confirm(`Souhaitez-vous vraiment envoyer un lien de réinitialisation de mot de passe à l'adresse ${this.ownerDetails.email} ?`)) {
                return;
            }

            this.loading = true;

            this.httpPost("/api/admin/owner/password/reset", { email: this.ownerDetails.email }).finally(() => (this.loading = false));
        },
        deleteOwner() {
            if (
                !confirm(
                    `Supprimer le restaurateur ${this.ownerDetails.firstname} ${this.ownerDetails.lastname} ? Cette action est irréversible et supprime l'ensemble des données.`
                )
            ) {
                return;
            }

            this.loading = true;

            this.$store
                .dispatch("admin/deleteOwner", { owner_id: this.ownerDetails.id })
                .then((response) => {
                    this.notifySuccess(response);

                    this.$emit("owner-deleted");
                })
                .catch((error) => {
                    this.notifyError(error);
                })
                .finally(() => (this.loading = false));
        },
    },
};
</script>

<style scoped>
.show-owner-details-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.show-owner-details-header h6 {
    margin-bottom: 4px;
    color: #182b3c;
    font-size: 1rem;
    font-weight: 700;
}

.show-owner-details-header p {
    color: #607287;
    font-size: 0.86rem;
}

.show-owner-details-actions {
    display: flex;
    gap: 8px;
}

.show-owner-details-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
}

.show-owner-details-item {
    min-width: 0;
    padding: 12px;
    border: 1px solid #e2ebf1;
    border-radius: 6px;
    background: #fbfdff;
}

.show-owner-details-item span {
    display: block;
    margin-bottom: 5px;
    color: #627184;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
}

.show-owner-details-item strong {
    display: block;
    color: #182b3c;
    font-size: 0.92rem;
    word-break: break-word;
}

@media (max-width: 991.98px) {
    .show-owner-details-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 575.98px) {
    .show-owner-details-header {
        flex-direction: column;
    }

    .show-owner-details-grid {
        grid-template-columns: 1fr;
    }
}
</style>
